import { FC } from "react";
import { ManageQuickBooksIntegration } from "../../AdminSettings/ManageQuickBooksIntegration/ManageQuickBooksIntegration";

export const ConfigQuickBooksIntegration: FC = () => {
  return <ManageQuickBooksIntegration />;
};
